.toc {
    padding-top: var(--mantine-spacing-xs);
    scroll-target-group: auto;
}

.label {
    text-transform: uppercase;
    font-size: 0.6875rem;
    font-weight: 700;
    color: var(--mantine-color-gneis-5);
    letter-spacing: 0.08em;
    padding-bottom: 0.75rem;
}

.list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.children {
    list-style: none;
    margin: 0;
    padding: 0 0 0 0.5rem;
}

.item {
    position: relative;
}

.link {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    text-decoration: none;
    font-size: 0.875rem;
    line-height: 1.45;
    color: var(--mantine-color-gneis-6);
    padding: 0.3rem 0 0.3rem 0.75rem;
    border-left: 2px solid transparent;
    overflow-wrap: anywhere;
    transition:
        color var(--transition-duration-fast) var(--transition-ease-smooth),
        border-color var(--transition-duration-fast)
            var(--transition-ease-smooth);

    &:hover {
        color: var(--mantine-color-gneis-9);
    }

    &.active {
        color: #2f7e6c;
        border-left-color: #2f7e6c;
        font-weight: 600;
    }

    /* Nested items use smaller font */
    .children & {
        font-size: 0.8125rem;
    }
}

/* Expand/collapse animation via grid */
.collapse {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.25s var(--transition-ease-smooth);
    overflow: hidden;
}

.collapse > .children {
    min-height: 0;
}

/* :target-current active only when JS click-override is not set */
.toc:not([data-click-override]) .link:target-current {
    color: #2f7e6c;
    border-left-color: #2f7e6c;
    font-weight: 600;
}

/* Expand when parent or any descendant is the active scroll target */
.toc:not([data-click-override]) .item:has(:target-current) > .collapse,
.item:has(.active) > .collapse {
    grid-template-rows: 1fr;
}
